import { render, staticRenderFns } from "./TrainingCenters.vue?vue&type=template&id=4d8ed07c&scoped=true&"
import script from "./TrainingCenters.vue?vue&type=script&lang=js&"
export * from "./TrainingCenters.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCenters.vue?vue&type=style&index=0&id=4d8ed07c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8ed07c",
  null
  
)

export default component.exports